import AdminHANavigation from './AdminHANavigation';

export default AdminHANavigation;
